import { FC } from "react";
import { Route, Routes } from "react-router-dom";
import Main from "../components/pages/main/Main";

const UnAuthRoutes: FC = () => {
    return (
        <Routes>
            <Route path="/" element={<Main />} />
        </Routes>
    );
};

export default UnAuthRoutes;
